import { ThemeProvider, CssBaseline } from '@mui/material'
import { theme } from './theme'
import ErrorBoundary from './_error'
import HomeContainer from './containers/home'
// import { LanguageSwitcher } from './components/ui/languageSwitcher'
import { DebugPopup } from './components/ui/debugPopup'

// Initialize i18n
import './i18n'

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <HomeContainer />
        {/* <LanguageSwitcher /> */}
        <DebugPopup />
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export default App
